var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 53,
    viewBox: "0 0 63 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4775 12.671C44.8548 19.0986 38.4882 24.3421 31.4989 24.3421C24.5096 24.3421 18.1318 19.0998 17.5203 12.671C16.8849 5.98451 23.0799 1 31.4989 1C39.9178 1 46.1129 6.10608 45.4775 12.671Z",
    stroke: "#596394",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4992 32.125C17.6794 32.125 3.65315 37.9605 1.05757 48.9751C0.744641 50.3027 1.72632 51.5767 3.54195 51.5767H59.4565C61.2737 51.5767 62.2554 50.3027 61.9424 48.9751C59.3453 37.9605 45.319 32.125 31.4992 32.125Z",
    stroke: "#596394",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientIcon);
export default __webpack_public_path__ + "static/media/clientIcon.fba6db7e05136dfa4af6cf7b86cca98d.svg";
export { ForwardRef as ReactComponent };